import { render } from "./CollectionUtilsAnalytics.vue?vue&type=template&id=071ed834"
import script from "./CollectionUtilsAnalytics.vue?vue&type=script&lang=js"
export * from "./CollectionUtilsAnalytics.vue?vue&type=script&lang=js"

import "./CollectionUtilsAnalytics.vue?vue&type=style&index=0&id=071ed834&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__